import React from "react";

import { ElementLinkModel } from "@courses-pm2/api";

import { openInternalLink } from "@apps/viewer/src/ts/utils/openInternalLink";

type ElementLinkProps = {
    /**
     * The model contains the contents and the desired configurations of the
     * component.
     */
    model: ElementLinkModel;
};

/**
 * Element links cannot be easily resolved within the course viewer, as they
 * are pointing within a portal - as such we'll need to open a new window and
 * point to the absolute link.
 */
export class ElementLink extends React.PureComponent<ElementLinkProps> {
    /**
     * Primary render method.
     */
    public render(): React.JSX.Element {
        return (
            <a
                className="elementLinnk"
                href="javascript:void()"
                onClick={this.onClick}
            >
                {this.props.model.render()}

                <style jsx>{`
                    a {
                        /** Apply font styling */
                        color: #dc4320;
                        text-decoration: none;

                        /** Apply hover styling */
                        &:hover {
                            text-decoration: underline;
                        }
                    }
                `}</style>
            </a>
        );
    }

    /**
     * Listener that's triggered when the user clicks an internal link, making
     * sure that the link is going to be opened.
     */
    protected onClick = () => {
        const { model } = this.props;

        openInternalLink({
            path: `/learningObject/${model.elementId}`,
            portalId: model.portalId,
        })
            .catch(() => { /* Errors are handled internally, ignore silently... */ });
    }
}
